if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.section = this.closest('.js-product');
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.externalInventoryNotice = this.querySelector('.js-external-inventory-notice')
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');

      // Bind to on:variant:change event for this product
      this.hasVariants = !!this.section.querySelector('variant-picker');
      this.section.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      if (this.hasVariants) {
        // .js-inventory-data holds the selected variant, and is empty while
        // no variant is chosen yet (combined listings start with one).
        const inventory = this.getVariantInventory();
        if (inventory && inventory.inventory_quantity !== undefined) {
          this.showVariantInventory(inventory);
        } else {
          this.hidden = true;
        }
      } else {
        this.hidden = false;
        this.updateInventory(
          parseInt(this.dataset.inventoryQuantity, 10),
          this.dataset.variantAvailable === 'true',
          this.dataset.inventoryPolicy,
          this.externalInventoryNotice.innerText
        );
      }
    }

    /**
     * Gets the inventory data of the selected variant
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.closest('.product-info').querySelector('.js-inventory-data');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.showVariantInventory(this.getVariantInventory());
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     * Shows the inventory of the selected variant, incl. external stock.
     * @param {object} inventory - Data from .js-inventory-data.
     */
    showVariantInventory(inventory) {
      this.updateInventory(
        inventory.inventory_quantity,
        inventory.available,
        inventory.inventory_policy,
        inventory.external_inventory
      );
      this.hidden = false;
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy, externalInventory) {
      let inventoryLevel;
      let primaryInventoryClass = document.querySelector('.c14-list-item.cc-primary-inventory');
      let secondaryInventoryClass = document.querySelector('.c14-list-item.cc-secondary-inventory');
      let noInventoryClass = document.querySelector('.c14-list-item.cc-no-inventory');

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      // Update external inventory
      if (externalInventory) {
        this.externalInventoryNotice.innerText = externalInventory;
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count).split(' ')[0];
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }
      } else {
         this.hidden = true;
      }

      // Show or hide inventory
      primaryInventoryClass.style.display = count > 0 ? 'block' : 'none';
      secondaryInventoryClass.style.display = externalInventory > 0 ? 'block' : 'none';
      noInventoryClass.style.display = count <= 0 && externalInventory <= 0 ? 'block' : 'none';
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
